import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import type { AdminApiOptions } from 'cloudinary';
import {
  type CloudinaryFolder,
  type CloudinaryGetSubFolderResult,
  getSubFolders,
} from '@/services/cloudinary';

interface GetSubFoldersProperties {
  path: string;
  options?: AdminApiOptions;
}

export default function useGetSubFolders({
  path,
  options = {},
}: GetSubFoldersProperties): UseQueryResult<CloudinaryFolder[]> {
  return useQuery({
    queryFn: () => getSubFolders(path, options),
    queryKey: ['get_sub_folders', options, path],
    select: (data: CloudinaryGetSubFolderResult) => data.folders,
  });
}
